<div id="dialog-container" class="dialog-container">
  @if (!data.undraggable) {
    <div cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" class="dialog-header drag">
      <h4>{{ data.header || data.title | translate }}</h4>
      @if (!data.hideAllButtons) {
        <button class="icon-close" type="button" (click)="closeDialog()"></button>
      }
    </div>
  } @else {
    <div class="dialog-header">
      <h4>{{ data.header || data.title | translate }}</h4>
      @if (!data.hideAllButtons) {
        <button class="icon-close" type="button" (click)="closeDialog()"></button>
      }
    </div>
  }
  <div class="container">
    <div class="section-container content">
      <span [innerHTML]="data.message | translate"></span>
      @if (data.sureQuestion) {
        <span>{{ "dialog.generic.areYouSure" | translate }}</span>
      }
      @if (data.textareaText && ((data.checkbox && !checked) || !data.checkbox)) {
        <div class="label-textarea">
          <label>{{ data.textareaText | translate }}</label>
          <textarea matInput [(ngModel)]="textareaValue"></textarea>
        </div>
      }

      @if (data.checkbox) {
        <div class="label-checkbox">
          <mat-checkbox (ngModelChange)="checkTextarea()" [(ngModel)]="checked" labelPosition="after">
            {{ data.checkbox | translate }}
          </mat-checkbox>
        </div>
      }
    </div>
  </div>
  @if (!data.hideAllButtons) {
    <div class="container container--sticky-bottom">
      <div class="section-container button-container">
        @if (!data.hideCancelButton) {
          <sag-ui-button color="secondary" (click)="closeDialog()">
            {{ "generic.buttons.cancel" | translate }}
          </sag-ui-button>
        }
        <sag-ui-button (click)="confirmDialog()">
          {{ data.confirmText || "generic.buttons.confirm" | translate }}
        </sag-ui-button>
      </div>
    </div>
  }
</div>
